<template>
  <default-empty-layout>
    <login></login>
  </default-empty-layout>
</template>

<script>
import DefaultEmptyLayout from '@/layout/default-empty-layout.vue';
import Login from '@/views-v3/Login/index.vue';

export default {
  components: { DefaultEmptyLayout, Login },
};
</script>